module.exports = "https://coursera_assets.s3.amazonaws.com/images/0b8ab49d4e3b13f4fce465389d8575e2.png";